module.exports = __webpack_public_path__ + "assets/img/微信客服.98829ff5.jpg";